import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'

import { listenToSelectTagDropdownClick } from './infographics'
import { initFullPage } from './fullPage'
import { loadImages } from './projectItemImages'
import { showSideMenu } from './sideMenu'
import { initQuote } from './quoteRequest'

Rails.start()
// Turbolinks.start()
ActiveStorage.start()

let page

document.addEventListener('DOMContentLoaded', () => {
  page = document.body.dataset.page

  console.log('Application JS loaded. Page: ', page)

  showSideMenu()

  if (page !== 'quote')
    initFullPage(page)

  switch (page) {
    case 'infographics' :
      listenToSelectTagDropdownClick()
      break
    case 'quote' :
      initQuote()
      break
  }
})

window.addEventListener('load', () => {
  if (page === 'index' || page === 'infographics' || page === 'contact' || page === 'show_project')
    loadImages()
})
